<script setup lang="ts">
import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';
import { ref } from 'vue';

import { useContactsStore } from '@/entities/Stores/Contacts';

// Этот попап будет все равно удален
import { HotlineButton } from '@/features/CallToHotline';
import { WhatsAppButton } from '@/features/CallToWhatsApp';
import { RequestCallback } from '@/features/RequestCallback';

import { VReminder } from '@/shared/ui/VReminder';

const emit = defineEmits<Emits>();
const contactsStore = useContactsStore();
const callbackSent = ref(false);

interface Emits {
  (e: 'close'): void;
}
</script>

<template>
  <div class="footer-widget__help-popup__wrapper">
    <h3
      v-if="!callbackSent"
      class="footer-widget__help-popup__title"
    >
      {{ $t('qic.help.footerlink') }}
    </h3>

    <div
      v-if="!callbackSent"
      class="footer-widget__help-popup__content"
    >
      <div class="footer-widget__help-popup__content__buttons">
        <WhatsAppButton :href="contactsStore.whatsAppLink" />
        <HotlineButton :phone="contactsStore.phone" />
      </div>
      <div class="footer-widget__help-popup__content__callback">
        <p class="footer-widget__help-popup__content__callback__desc">
          {{ $t('qic.help.callback') }}
        </p>
        <div class="footer-widget__help-popup__content__callback__phone">
          <RequestCallback @callback="callbackSent = true" />
        </div>
      </div>
      <VReminder icon="lock">
        {{ $t('qic.data-reminder') }}
      </VReminder>
    </div>

    <div
      v-else
      class="footer-widget__help-popup__content"
    >
      <div class="footer-widget__help-popup__content__callback">
        <div class="footer-widget__help-popup__content__callback__recieved">
          {{ $t('qic.help.recieved_request') }}
        </div>
        <p class="footer-widget__help-popup__content__callback__time">
          {{ $t('qic.help.callback_time') }}
        </p>
      </div>

      <ButtonQC
        icon="none"
        @click="emit('close')"
      >
        {{ $t('qic.ok') }}
      </ButtonQC>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@styles/utils' as *;

.footer-widget {
  &__help-popup {
    &__btn {
      @include text-medium;

      color: var(--colorTxtSrfSecondary);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-top: 56px;
      margin-bottom: 40px;
      gap: var(--spacing-2);

      @media (width <= $flow-width) {
        margin-bottom: 24px;
      }
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      gap: 32px;
      padding: 0 16px;
      width: 424px;

      @media (width <= 550px) {
        padding: inherit;
        width: 100%;
      }
    }

    &__title {
      @include heading-2;

      font-weight: 500;
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 32px;

      &__buttons,
      &__callback {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
      }

      &__callback {
        &__desc {
          @include text-medium;
        }

        &__phone {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        &__recieved {
          align-items: center;
          background: #daffce;
          border-radius: 16px;
          color: #18b97d;
          display: flex;
          flex-direction: row;
          font-size: 24px;
          font-weight: 500;
          justify-content: center;
          line-height: 32px;
          min-height: 112px;
          padding: 24px 16px;
          text-align: center;
          width: 100%;
        }

        &__time {
          @include heading-6;

          font-weight: 500;
        }
      }
    }
  }
}
</style>
